<script setup>
import { computed } from "vue";

const props = defineProps({
  for: {
    type: String,
    default: null,
  },
  required: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  size: {
    type: String,
    default: "md",
    validator(value) {
      return ["sm", "md", "lg"].includes(value);
    },
  },
  as: {
    type: String,
    default: "label",
    validator(value) {
      return ["label", "legend"].includes(value);
    },
  },
});

const targetId = computed(() => props.for);
const labelId = computed(() => (targetId.value ? targetId.value + "Label" : null));
const descriptionId = computed(() => (targetId.value ? targetId.value + "Optional" : null));
</script>

<template>
  <div class="flex grow items-baseline justify-between">
    <component
      :is="as"
      :id="labelId"
      :for="as === 'label' ? targetId : undefined"
      class="block font-medium"
      :class="[size === 'sm' ? 'mb-0.5 text-xs' : 'mb-1 text-sm', disabled ? 'text-gray-400' : 'text-gray-700']"
    >
      <slot />
    </component>
    <span v-if="!required" :id="descriptionId" class="text-xs text-gray-400"> Valgfri </span>
  </div>
</template>
